module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tile is-vertical is-12"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile is-parent is-vertical is-3"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('p', {
    staticClass: "title has-text-white"
  }, [_vm._v("🦠 Social")]), _vm._v(" "), _vm._l((_vm.socials), function(item) {
    return _c('span', {
      key: item.url,
      staticClass: "social-icons"
    }, [_c('a', {
      staticClass: "social-icon",
      attrs: {
        "href": item.url,
        "target": "_blank",
        "rel": "noopener",
        "aria-hidden": "true"
      }
    }, [(item.icon) ? _c('font-awesome-icon', {
      attrs: {
        "icon": item.icon
      }
    }) : _vm._e()], 1)])
  }), _c('br')], 2), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-vertical is-3"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('p', {
    staticClass: "title has-text-white"
  }, [_vm._v("📍Find us on")]), _vm._v(" "), _c('p', [_vm._v("Progressbar Cowork & Hackerspace")]), _vm._v(" "), _c('p', [_vm._v("Dunajská 7495/14")]), _vm._v(" "), _c('p', [_vm._v("811 08, Bratislava")]), _vm._v(" "), _c('p', [_vm._v("Slovakia 🇸🇰")]), _vm._v(" "), _vm._l((_vm.mapUrls), function(item) {
    return _c('div', {
      key: item.url
    }, [_c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank",
        "rel": "noopener"
      }
    }, [_vm._v(_vm._s(item.title))])])
  })], 2), _vm._v(" "), _c('article', {
    staticClass: "tile is-child"
  }, [_c('p', {
    staticClass: "title has-text-white"
  }, [_vm._v("👩‍💼 Services")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/rent-flex-desk-coworking-bratislava"
    }
  }, [_vm._v("\n              Rent Flex Desk in Cowork\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/rent-fix-desk-coworking-bratislava"
    }
  }, [_vm._v("\n              Rent Fix Desk in Cowork\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/rent-meeting-room-coworking-bratislava"
    }
  }, [_vm._v("\n              Rent Meeting Room\n          ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/rent-private-office-bratislava"
    }
  }, [_vm._v("\n              Rent Private Office\n            ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/rent-a-space"
    }
  }, [_vm._v("\n              Rent Venue Space\n            ")])], 1)])])]), _vm._v(" "), _c('article', {
    staticClass: "tile is-child"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "title has-text-white"
  }, [_vm._v("🐚 History")]), _vm._v(" "), _c('ul', [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', [_vm._v("\n            If you think we are doing great thing\n            "), _c('ul', [_c('li', [_vm._v("\n                Join Our "), _c('router-link', {
    attrs: {
      "to": "/contact-venue"
    }
  }, [_vm._v("Coworking")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pay"
    }
  }, [_vm._v("You Can Support Us!")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/network"
    }
  }, [_vm._v("Be Our Proud Sponsor!")])], 1)])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "column is-6 has-text-right"
  }, [_c('small', {
    attrs: {
      "aria-label": "copyright"
    }
  }, [_vm._v("2010 - " + _vm._s(_vm.currentYear) + " © Progressbar Cowork")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "tile is-child"
  }, [_c('p', {
    staticClass: "title has-text-white"
  }, [_vm._v("🌐 Network")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.bitfwd.com/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/partners/bitfwd.png",
      "loading": "lazy",
      "alt": "community driven venture network"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://starfish.network/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/partners/Starfish_Logo_Horizontal Mission@4x.png",
      "loading": "lazy",
      "alt": "starfish mission san francisco blockchain space"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-parent is-vertical"
  }, [_c('a', {
    staticClass: "twitter-timeline",
    attrs: {
      "data-theme": "dark",
      "data-height": "900",
      "href": "https://twitter.com/progressbarsk?ref_src=twsrc%5Etfw"
    }
  }, [_vm._v("Tweets by @progressbarsk\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v("\n            We started as "), _c('a', {
    attrs: {
      "href": "https://progressbar.sk"
    }
  }, [_vm._v("first Slovak hackerspace")]), _vm._v(" back in June 2010,\n            this is our 4th place as we went through expansion and "), _c('a', {
    attrs: {
      "href": "https://progressbar.sk/calendar"
    }
  }, [_vm._v("held more than 1200 meetups")]), _vm._v(".\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v("\n            In September 2017 we've considered to keep up our 💸 cashflow & our existence. We've started thinking about daily utilization.\n            "), _c('br'), _vm._v(" We came up with idea to open "), _c('a', {
    attrs: {
      "href": "https://t.me/coworkprogressbar"
    }
  }, [_vm._v("coworking")]), _vm._v(" in our hackerspace Progressbar in Bratislava.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-6"
  }, [_c('small', [_c('a', {
    attrs: {
      "href": "https://github.com/Progressbar/progressbar-coweb",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("/src")]), _vm._v(" (Feel free to help ❤️)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7207c16b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppFooter.vue
// module id = 92
// module chunks = 24